import JustValidate from 'just-validate'

export default class ContactForm {
  static init() {
    console.log('== Contact Form component ==')

    const form = document.querySelector('#contact-form')
    const formSubmittButton = form.querySelector('.form-button.submit')

    let postBody = {}

    // init validation
    const validation = new JustValidate('#contact-form')

    validation
      .addField('#contactName', [
        {
          rule: 'required',
          errorMessage: translations?.contact_us?.form?.name?.required_error || 'Name field is required',
        },
      ])
      .addField('#contactSurname', [
        {
          rule: 'required',
          errorMessage: translations?.contact_us?.form?.surname?.required_error || 'Surname is required',
        },
      ])
      .addField('#contactCompany', [
        {
          rule: 'required',
          errorMessage: translations?.contact_us?.form?.company?.required_error || 'Company is required',
        },
      ])
      .addField('#contactEmail', [
        {
          rule: 'required',
          errorMessage: translations?.contact_us?.form?.email?.required_error || 'Email is required',
        },
        {
          rule: 'email',
          errorMessage: translations?.contact_us?.form?.email?.format_error || 'Email is not valid',
        },
      ])
      .addField('#contactNotes', [
        {
          rule: 'required',
          errorMessage: translations?.contact_us?.form?.message?.required_error || 'Message is required',
        },
      ])
      .addField('#contactPrivacy', [
        {
          rule: 'required',
          errorMessage:
            translations?.contact_us?.form?.privacy?.required_error || 'You must agree with privacy policy terms to submit you request',
        },
      ])
      .onSuccess((event) => {
        formSubmittButton.classList.add('h-disabled')

        postBody = {
          contactName: form.elements.contactName.value,
          contactSurname: form.elements.contactSurname.value,
          contactCompany: form.elements.contactCompany.value,
          contactEmail: form.elements.contactEmail.value,
          contactNotes: form.elements.contactNotes.value,
        }

        const formSubmissionMsgOK = document.querySelector(
          '.form-submission-message.success'
        )
        const formSubmissionMsgKO = document.querySelector(
          '.form-submission-message.error'
        )

        const asyncPostCall = async () => {
          formSubmissionMsgOK.classList.remove('show')
          formSubmissionMsgKO.classList.remove('show')
          // console.log('Email body:', postBody)

          if( form.elements.foodNeeds.value ){
            formSubmissionMsgOK.classList.add('show')
            formSubmittButton.classList.remove('h-disabled')
            form.reset()
          } else{
            try {
              const response = await fetch('/sendMail.php', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(postBody),
              })
  
              const result = await response.text()
  
              console.log('Result:', result)
  
              if( result === 'Mail inviata correttamente!' ){
                formSubmissionMsgOK.classList.add('show')
                form.reset()
              } else {
                formSubmissionMsgKO.classList.add('show')
              }
  
              formSubmittButton.classList.remove('h-disabled')
            } catch (error) {
              formSubmissionMsgKO.classList.add('show')
              formSubmittButton.classList.remove('h-disabled')
              console.log(error)
            }
          }
        }

        asyncPostCall()
      })
  }
}
